import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-role-edit',
  templateUrl: './role-edit.component.html',
  styleUrl: './role-edit.component.scss',
  providers: [MessageService],
})
export class RoleEditComponent implements OnInit {
  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  
  pageTitle:string="Nuovo ruolo";
  backUrl:string='/roles';
  action:any='';
  loading:boolean = true;
  selectedItems:any[]=[];

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    public lang:LanguageService
  ) { }

  ngOnInit(): void {
   
    let modulefields=this.globalService.configModules.filter((m)=>m.name=='roles');
    this.tabsFields=modulefields[0].tabsFields;

    this.action=this.route.snapshot.paramMap.get('action');

    if(this.route.snapshot.paramMap.get('id')){
      this.pageTitle="Modifica ruolo";
      this.apiService.post('auth/roles_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        this.loading=false;
      });
    }
 
    
  }

  valida(){
  return true;
  }

  save(){
    
    this.model['logged_user_id']=this.globalService.getUser().id;
    this.apiService.post('auth/role_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      setTimeout(()=>{
        this.router.navigateByUrl(this.backUrl);
      },2000);
    
    });

  }
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
}
